<template>
  <span
    :class="connectorClasses"
    aria-hidden="true"
    data-cy="ds-content-connector"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { DSContentConnectorProps } from "@/src/design_system/primitives/content_connector/types";
import { DS_CONTENT_CONNECTOR_SIZES } from "@/src/design_system/primitives/content_connector/types";
import {
  DS_CONTENT_CONNECTOR_CLASSES,
  DS_CONTENT_CONNECTOR_SIZE_TO_CLASS_MAP,
} from "@/src/design_system/primitives/content_connector/constants/classes";

const props = withDefaults(defineProps<DSContentConnectorProps>(), {
  size: DS_CONTENT_CONNECTOR_SIZES.Medium,
});

const connectorClasses = computed(() => [
  DS_CONTENT_CONNECTOR_CLASSES.Base,
  DS_CONTENT_CONNECTOR_SIZE_TO_CLASS_MAP[props.size],
]);
</script>
